export const locales = [
    { code: "en-US", label: "English" },
    { code: "nb-NO", label: "Norsk" },
    { code: "sv-SE", label: "Svenska" },
] as const;

export type Locale = (typeof locales)[number]["code"];

export const asLocale = (value: string | undefined): Locale | undefined => locales.find((l) => l.code === value)?.code;
